// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iqQ3g","header":"styles_header__URG8y","form_container":"styles_form_container__+fkzF"};